import { SHOULD_SHOW_FULLSCREEN } from 'app/constants/globalVariables'
import { getHostWebsiteUrl } from './links'
import { WIDGET_MAIN_URL } from './urls'

/**
 * this function checks if global variable for always full screen exists or if the address is amont addresses that widget should show in full screen mode in them
 *
 * @returns boolean
 */
export function showAlwaysFullScreen(channel_id) {
  const urlWidgetShouldGetFullScreenIn = `${WIDGET_MAIN_URL}/${channel_id}`
  const urlWidgetShouldGetFullScreenInWithV2Suffix = urlWidgetShouldGetFullScreenIn + '?version=2'

  const currentUrl = getHostWebsiteUrl()
  const globalVariable = window[SHOULD_SHOW_FULLSCREEN] || window.parent?.[SHOULD_SHOW_FULLSCREEN]

  const showFullScreen =
    globalVariable || [urlWidgetShouldGetFullScreenIn, urlWidgetShouldGetFullScreenInWithV2Suffix].includes(currentUrl)
  return showFullScreen
}
